import React from 'react';
import { connect } from 'react-redux';
import { selecthasUnreadAlerts } from '../../../../store/alerts/selectors';
import {
  selectHasAnyPermission,
  selectHasSomeRole,
  selectIsOnlyMiembro,
} from '../../../../store/auth/selectors';
import { RootState } from '../../../../store/store';
import styles from '../Layout/layout.module.scss';
import MenuUser from './MenuUser';
import MenuMiembro from './MenuMiembro';

interface MenuProps {
  isOpenMenu: boolean;
  userAvatar: string | null;
  canListUsers: boolean;
  canListOrganizaciones: boolean;
  canListMiembros: boolean;
  canListEntidades: boolean;
  canViewNotifications: boolean;
  canListDonaciones: boolean;
  canViewFacturacion: boolean;
  canViewSolicitudes: boolean;
  canViewAcompanamiento: boolean;
  canReadDonacionOwn: boolean;
  canViewComunicaciones: boolean;
  canViewIndicadores: boolean;
  canViewRecursos: boolean;
  canPublishComunicaciones: boolean;
  canListActividades: boolean;
  hasUnreadAlerts: boolean;
  isMiembro: boolean;
  isAdmin: boolean;
  isOnlyMiembro: boolean;
  isRA: boolean;
  isRE: boolean;
  setIsOpenMenu: (open: boolean) => void;
  styleRoute: (route: string) => string;
}

const Menu: React.FC<MenuProps> = ({
  isOpenMenu,
  canListUsers,
  canListOrganizaciones,
  canListEntidades,
  canViewNotifications,
  canViewSolicitudes,
  canViewAcompanamiento,
  canListDonaciones,
  canReadDonacionOwn,
  canViewComunicaciones,
  canPublishComunicaciones,
  canListActividades,
  canViewIndicadores,
  canViewRecursos,
  hasUnreadAlerts,
  isMiembro,
  isAdmin,
  isOnlyMiembro,
  isRA,
  isRE,
  setIsOpenMenu,
  canListMiembros,
  canViewFacturacion,
  styleRoute,
}) => {
  return (
    <nav
      data-testid={isOpenMenu ? 'isMenuVisible' : 'isMenuHidden'}
      className={`${styles.navigation} ${isOpenMenu && styles.isOpen}`}
    >
      <button
        aria-label={isOpenMenu ? 'Cerrar menú' : 'Abrir menú'}
        onClick={() => setIsOpenMenu(!isOpenMenu)}
        className={`${styles.burger} ${styles.icon} ${
          isOpenMenu ? styles.isOpen : ''
        }`}
        type="button"
      >
        <span className={styles.burgerBox}>
          <span className={styles.burgerInner}></span>
        </span>
      </button>
      {!isOnlyMiembro && !isRA && !isRE && (
        <MenuUser
          isOpenMenu={isOpenMenu}
          canListUsers={canListUsers}
          canListOrganizaciones={canListOrganizaciones}
          canListEntidades={canListEntidades}
          canViewSolicitudes={canViewSolicitudes}
          canListDonaciones={canListDonaciones}
          canViewComunicaciones={canViewComunicaciones}
          canListMiembros={canListMiembros}
          canViewFacturacion={canViewFacturacion}
          canListActividades={canListActividades}
          canViewIndicadores={canViewIndicadores}
          isAdmin={isAdmin}
          styleRoute={styleRoute}
        />
      )}
      <MenuMiembro
        isOpenMenu={isOpenMenu}
        canViewNotifications={canViewNotifications}
        canViewAcompanamiento={canViewAcompanamiento}
        canReadDonacionOwn={canReadDonacionOwn}
        canPublishComunicaciones={canPublishComunicaciones}
        canViewRecursos={canViewRecursos}
        hasUnreadAlerts={hasUnreadAlerts}
        isMiembro={isMiembro}
        isAdmin={isAdmin}
        isOnlyMiembro={isOnlyMiembro || isRA || isRE}
        styleRoute={styleRoute}
      />
    </nav>
  );
};

export default connect((state: RootState) => ({
  canListUsers: selectHasSomeRole(state, ['admin', 'coordinador']),
  canListOrganizaciones: selectHasAnyPermission(state, ['read_organizacion']),
  canListEntidades: selectHasAnyPermission(state, ['create_entidad']),
  canListDonaciones: selectHasAnyPermission(state, ['read_donacion']),
  canListMiembros: selectHasAnyPermission(state, ['read_miembro']),
  canReadDonacionOwn: selectHasAnyPermission(state, ['read_donacion_own']),
  canViewAcompanamiento: selectHasAnyPermission(state, [
    'read_solicitud',
    'create_solicitud',
  ]),
  canViewNotifications: selectHasAnyPermission(state, ['read_notification']),
  canViewFacturacion: selectHasAnyPermission(state, ['read_facturacion']),
  canViewSolicitudes: selectHasAnyPermission(state, ['read_all_solicitud']),
  canViewComunicaciones: selectHasAnyPermission(state, ['read_comunicacion']),
  canPublishComunicaciones: selectHasSomeRole(state, ['miembro']),
  canListActividades: selectHasAnyPermission(state, ['read_actividad']),
  canViewIndicadores: selectHasSomeRole(state, ['admin', 'coordinador']),
  canViewRecursos: selectHasAnyPermission(state, ['read_resource']),
  hasUnreadAlerts: selecthasUnreadAlerts(state),
  isMiembro: selectHasSomeRole(state, ['miembro']),
  isAdmin: selectHasSomeRole(state, ['admin']),
  isRE: selectHasSomeRole(state, ['responsable_entidad']),
  isRA: selectHasSomeRole(state, ['responsable_ayuntamiento']),
  isOnlyMiembro: selectIsOnlyMiembro(state),
}))(Menu);
